if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        this.submitButton = this.querySelector('[type="submit"]');

        if (!this.submitButton) return;

        this.submitButtonText =
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          !this.submitButton ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        const spinner =
          this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (
          this.cart &&
          typeof this.cart.getSectionsToRender ===
            'function'
        ) {
          const sections =
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(',');

          formData.append('sections', sections);

          formData.append(
            'sections_url',
            window.location.pathname
          );

          if (
            typeof this.cart.setActiveElement ===
            'function'
          ) {
            this.cart.setActiveElement(
              document.activeElement
            );
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())

          .then(async (response) => {
            if (response.status) {
              if (
                typeof publish === 'function' &&
                typeof PUB_SUB_EVENTS !==
                  'undefined'
              ) {
                publish(
                  PUB_SUB_EVENTS.cartError,
                  {
                    source: 'product-form',

                    productVariantId:
                      formData.get('id'),

                    errors:
                      response.errors ||
                      response.description,

                    message:
                      response.message,
                  }
                );
              }

              this.handleErrorMessage(
                response.description ||
                response.message
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (soldOutMessage) {
                this.submitButton.setAttribute(
                  'aria-disabled',
                  true
                );

                if (this.submitButtonText) {
                  this.submitButtonText.classList.add(
                    'hidden'
                  );
                }

                soldOutMessage.classList.remove(
                  'hidden'
                );
              }

              this.error = true;

              return;
            }

            if (!this.cart) {
              window.location =
                window.routes.cart_url;

              return;
            }

            const startMarker =
              typeof CartPerformance !==
                'undefined'
                ? CartPerformance.createStartingMarker(
                    'add:wait-for-subscribers'
                  )
                : null;

            if (
              !this.error &&
              typeof publish === 'function' &&
              typeof PUB_SUB_EVENTS !==
                'undefined' &&
              PUB_SUB_EVENTS.cartUpdate
            ) {
              try {
                await publish(
                  PUB_SUB_EVENTS.cartUpdate,
                  {
                    source: 'product-form',

                    productVariantId:
                      formData.get('id'),

                    cartData: response,
                  }
                );
              } catch (error) {
                console.error(
                  'Cart update publish error:',
                  error
                );
              }

              if (
                startMarker &&
                typeof CartPerformance !==
                  'undefined'
              ) {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              }
            }

            this.error = false;

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.renderCart(
                      response
                    );
                  });
                },
                {
                  once: true,
                }
              );

              quickAddModal.hide(true);

              return;
            }

            this.renderCart(response);
          })

          .catch((error) => {
            console.error(
              'Add to cart error:',
              error
            );

            this.handleErrorMessage(
              'Something went wrong. Please try again.'
            );

            this.error = true;
          })

          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            const cartItems =
              this.cart?.querySelector?.(
                'cart-drawer-items'
              );

            if (
              cartItems &&
              cartItems.classList.contains(
                'is-empty'
              )
            ) {
              cartItems.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            if (spinner) {
              spinner.classList.add('hidden');
            }

            if (
              typeof CartPerformance !==
              'undefined'
            ) {
              CartPerformance.measureFromEvent(
                'add:user-action',
                evt
              );
            }
          });
      }

      renderCart(response) {
        if (!this.cart) return;

        if (
          typeof this.cart.renderContents ===
          'function'
        ) {
          if (
            typeof CartPerformance !==
            'undefined'
          ) {
            CartPerformance.measure(
              'add:paint-updated-sections',
              () => {
                this.cart.renderContents(
                  response
                );
              }
            );
          } else {
            this.cart.renderContents(
              response
            );
          }
        }

        this.cart.classList.remove(
          'is-empty'
        );

        const cartItems =
          this.cart.querySelector(
            'cart-drawer-items'
          );

        if (cartItems) {
          cartItems.classList.remove(
            'is-empty'
          );
        }

        const drawerContents =
          this.cart.querySelector(
            '.drawer__contents'
          );

        if (drawerContents) {
          drawerContents.classList.remove(
            'is-empty'
          );
        }

        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );

        if (cartDrawer) {
          cartDrawer.classList.remove(
            'is-empty'
          );

          const drawerItems =
            cartDrawer.querySelector(
              'cart-drawer-items'
            );

          if (drawerItems) {
            drawerItems.classList.remove(
              'is-empty'
            );
          }
        }

        if (
          typeof this.cart.open ===
          'function'
        ) {
          setTimeout(() => {
            this.cart.open();
          }, 0);
        }

        document.dispatchEvent(
          new CustomEvent(
            'cart:updated',
            {
              bubbles: true,

              detail: {
                cartData: response,
              },
            }
          )
        );
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (
          !this.errorMessageWrapper
        ) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          if (
            this.submitButtonText &&
            window.variantStrings
          ) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}